import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'node_modules/rxjs';
import { environment } from '@src/environments/environment';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    standalone: false
})
export class SummaryComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute) { }

  public percentOfCompletion: Observable<string>;
  public passedparam: boolean;
  public traiDesc: string;
  public isYMUser: boolean;
  ngOnInit() {
    // this.route.queryParams.pipe(
    //   map((res1: Params) => res1['passed']),
    //   tap(val => this.passed = val),
    //   flatMap((res2) => this.)
    // ).subscribe
    this.route.queryParams.subscribe(param => {
      this.isYMUser = !!sessionStorage.getItem(environment.sessionIsYMUser);
      this.percentOfCompletion = param['percentOfCompletion'];
      this.passedparam = param['passed'] && param['passed'].toLowerCase() === 'true';
      this.traiDesc = sessionStorage.getItem(environment.sessionSelectedTrainingDesc);
      if(this.isYMUser && !this.passedparam){
        return;
      }
      sessionStorage.clear();
    });
  }

}
